















































































































import Vue from 'vue';
import { Component, } from 'vue-property-decorator';
import { UserState, ContextsState } from '@/store';
import notify from 'devextreme/ui/notify';
import { Role } from '@/dto';
import {
    CONTRACTS,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import PreprocessorsComponent from './components/ContextSettings.Preprocessors.vue';
import ContextComponent from './components/ContextSettings.Context.vue';
import InvitesComponent from './components/ContextSettings.Invites.vue';
import DxValidator, { DxCustomRule } from 'devextreme-vue/validator';
import RolesComponent from './components/ContextSettings.Roles.vue';
import UsersComponent from './components/ContextSettings.Users.vue';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import Page from '@/core/components/controls/Page.vue';
import DxTextBox from 'devextreme-vue/text-box';
import { DxPopup } from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import { localize } from '@/core/filters';

interface IUserModel {
    id: number;
    name: string;
    role: Role;
}

@Component({
    components: {
        DxPopup,
        DxButton,
        DxTextBox,
        DxValidator,
        DxCustomRule,
        RolesComponent,
        UsersComponent,
        ContextComponent,
        InvitesComponent,
        PreprocessorsComponent
    }
})
export default class ContextSettingsPage extends Page {
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    private currentUser: IUserModel | undefined;
    private isAdmin: boolean = false;
    private isValid: boolean = false;
    private popupVisible: boolean = false;
    private contextName: string | undefined;
    private permissionsGranted: boolean = false;
    private rolePermissions: Role | undefined;
    private isProcessing: boolean = false;

    public get localize() {
        return localize;
    }

    private mounted() {
        this.loadUser();
        this.contextName = ContextsState.current?.name;
        this._eventsService!.on(
            Events.ProcessingStarted,
            this.onProcessingStarted
        );
    }

    private async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingStarted,
            this.onProcessingStarted
        );
    }

    private onProcessingStarted() {
        this.popupVisible = false;
        this.isProcessing = false;
    }

    private validation(data: any): boolean {
        const valid = data.value === this.contextName;
        this.isValid = valid;
        return valid || data.value === '';
    }

    private async loadUser() {
        const currentContextId = ContextsState.currentContextId;
        const currentUserId = Number(UserState.current?.id!);
        const loadedSettings = await this._fetchService!
                               .get<Array<IUserModel>>('/contexts/' + currentContextId + '/users');
        const user = loadedSettings.find(u => u.id === currentUserId);
        this.rolePermissions = await this._fetchService!.get<Role>(
                '/contexts/' + currentContextId + '/roles/' + user?.role.id);
        if (user) {
            user.role = this.rolePermissions;
            const isAdmin = user?.role.isAdministrator;
            this.permissionsGranted = isAdmin ?
                                      true :
                                      user.role.permissions!
                                      .filter(permission => permission.enabled === false).length === 0;
            this.isAdmin = isAdmin ? isAdmin : false;
        }
    }

    private valueChanged() {
        const name = 'contextNameValidator';
        const element = this.$refs[name] as unknown;
        if (!element) {
            return false;
        }
        const validator = (element as DxValidator).instance!;
        return validator.validate().isValid !== undefined ? validator.validate().isValid! : false;
    }

    private get textFieldInstance(): DxTextBox {
        const name = 'textField';
        return this.$refs[name] as DxTextBox;
    }

    private async ok() {
        this.isProcessing = true;
        this.isValid = false;
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}/clear`;
        return await this._fetchService!.post<any>(url)
                            .then(result => {
                                this.isProcessing = false;
                                this.isValid = true;
                                this.popupVisible = false;
                            })
                            .catch(error => {
                                this.isProcessing = false;
                                this.isValid = true;
                                notify(
                                    localize('ClearContext_ProcessingErrorMessage'),
                                    'error',
                                    3000
                                );
                                throw error;
                            });
    }

    private cancel() {
        this.popupVisible = false;
    }

    private async clearContext() {
        await this.loadUser();
        if (this.isAdmin) {
            this.popupVisible = true;
            const name = 'textField';
            const textBox = this.$refs[name] as DxTextBox;
            textBox.instance?.option('value', '');
        }
    }
}
